export const cellStyle = {
    padding: '0px 0px 0px 10px',
}

export const getColumnStyle = (label) => {
    switch(label) {
        case 'status':
            return {
                padding: '0px 0px 0px 0px',
                textAlign: 'center'
            }
        case 'number':
            return {
                padding: '0px 10px 0px 10px',
                textAlign: 'center',
                fontSize: '1rem'
            }
        case 'type':
            return {
                padding: '0px 0px 0px 0px',
                textAlign: 'center',

            }
        default:
    }
}

export const getTypeStyle= (type) => {
    switch(type) {
        case 'CD':
            return {
                background: '#D5F5E3'
            }
        case 'QW':
            return {
                background: '#AED6F1'
            }
        case 'FR':
            return {
                background: '#F5CBA7'
            }
        default:
    }
}


export const getStatusStyle = (status) => {
    switch(status) {
        case 'R':
            return {
                background: '#D2B4DE'
            }
        case 'B':
            return {
                background: '#F9E79F'
            }
        default:
    }
}

export const getLinkButtonStyle = (statusSort) => {
    return {
        color: '#2874A6',
        textDecoration: 'underline',
        fontSize: '1rem',
        borderRadius: '12px',
        background: '#F8F9F9'
    }
}



export const getHeaderStyles = () => {
    return {
        fontSize: '1rem',
        textAlign: 'center'

    }
}


// WEBPACK FOOTER //
// ./src/js/styles/Assignment_Styles.js